module.exports = __webpack_public_path__ + "static/media/blom-pysanky-102.83131a09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-102.jpg
// module id = 3664
// module chunks = 15